<template>
   <div data-cy="cookies-revisit">
      <!-- Cookie categories with services -->
      <section v-if="cookieSettingsStore.cookieCategories">
         <h2 class="h3 mb-4">{{ $t("privacy-and-terms.cookie_policy.cookies_revisit_heading") }}</h2>
         <div
            v-for="cookieCategory in cookieSettingsStore.cookieCategories"
            :key="cookieCategory.category"
            class="mb-10 last-of-type:mb-0"
         >
            <h2 class="h4 flex items-center text-lg">
               <span class="text-regular">{{ cookieCategory.category }}</span>
               <span v-if="cookieCategory.isNecessary" class="ml-4 text-sm text-bolder text-green-60">
                  ({{ $t("privacy-and-terms.cookie_customise.always_on") }})
               </span>
            </h2>

            <p class="mt-2">{{ cookieCategory.description }}</p>

            <!-- cookies under this category -->
            <div v-if="cookieCategory.cookies" class="mt-4">
               <div
                  v-for="cookieItem in cookieCategory.cookies"
                  :key="cookieItem.id"
                  :data-cy="`cookie-category-${cookieItem.id}`"
                  class="mb-4 ml-4 last-of-type:mb-0"
               >
                  <h3 class="text-bolder">
                     {{ cookieItem.name }}
                  </h3>
                  <p>
                     {{ cookieItem.description }}
                  </p>
               </div>
            </div>
         </div>
      </section>

      <!-- Button to bring cookie customise modal back up -->
      <section v-if="cookieSettingsStore.cookieCategories" class="mt-10">
         <h2 class="h3 mb-2">{{ $t("privacy-and-terms.cookie_customise.heading") }}</h2>
         <p class="mb-2">
            {{ $t("privacy-and-terms.cookie_customise.customise_revisit.description") }}
         </p>

         <!-- Customise cookies -->
         <DefaultButton
            data-cy="cookie-policy-customise-btn"
            size="sm"
            class="mx-auto"
            @click="toggleCustomiseModal(true)"
         >
            {{ $t("privacy-and-terms.cookie_customise.customise_revisit.button_edit") }}
         </DefaultButton>

         <CookiesCustomiseModal :dialogIsOpen="showCustomiseModal" @close="toggleCustomiseModal(false)" />
      </section>
   </div>
</template>

<script setup lang="ts">
import { useCookieSettingsStore } from "@/stores/cookieSettingsStore";

// declarations
//-----------------------------------------------
const cookieSettingsStore = useCookieSettingsStore();

// state
const showCustomiseModal = ref(false);

// methods
//-----------------------------------------------
function toggleCustomiseModal(show: boolean) {
   showCustomiseModal.value = show;
}
</script>

<style scoped lang="scss"></style>
